import { UserManager, UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';
import React, { ReactNode, createContext, useState, useContext } from 'react';
import { oidcConfig } from '../auth/oidcService';
import { useEnv } from './EnvironmentContext';

// Create the context
const UserManagerContext = createContext<{
  userManager: UserManager;
  setUserManager: React.Dispatch<React.SetStateAction<UserManager>>;
} | undefined>(undefined);

// Context Provider to wrap around the app
export const UserManagerProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { env } = useEnv();
  const [userManager, setUserManager] = useState<UserManager>(()=>new UserManager(oidcConfig(env)));

  return (
    <UserManagerContext.Provider value={{ userManager, setUserManager }}>
      {children}
    </UserManagerContext.Provider>
  );
};

// Hook to use UserContext in other components
export const useUserManager = () => {
  const context = useContext(UserManagerContext);
  if (!context) {
    throw new Error("useType must be used within a TypeProvider");
  }
  return context;
};
